import { CategoryBlockData } from "../types";

/* Normalize number input */
export const normalizeVolume = (
  value: string | number | null | undefined
): string => {
  if (value == null) return "";
  return value.toString().trim().replace(/\s+/g, "");
};

/* Validate report */
export function validateReport(blocks: CategoryBlockData[]): string[] {
  const errors: string[] = [];

  blocks.forEach((block, blockIndex) => {
    if (!block.category?.trim()) {
      errors.push(`Blokk ${blockIndex + 1}: mangler produktkategori.`);
    }

    const rowCount = Math.max(block.products.length, block.volumes.length);

    for (let i = 0; i < rowCount; i++) {
      const product = block.products[i]?.trim() ?? "";
      const volume = normalizeVolume(block.volumes[i]);

      if (!product && !volume) continue;

      if (!product) {
        errors.push(`Blokk ${blockIndex + 1}, rad ${i + 1}: produkt mangler.`);
      }

      if (!volume) {
        errors.push(`Blokk ${blockIndex + 1}, rad ${i + 1}: volum mangler.`);
      } else if (isNaN(Number(volume))) {
        errors.push(
          `Blokk ${blockIndex + 1}, rad ${i + 1}: volum må være et tall.`
        );
      }
    }
  });

  return errors;
}

export function hasMissingVolume(blocks: CategoryBlockData[]): boolean {
  return blocks.some((block) =>
    block.products.some((_, idx) => {
      const product = block.products[idx]?.trim() ?? "";
      const vol = normalizeVolume(block.volumes[idx]);
      return product && !vol;
    })
  );
}

export function hasValidProductEntry(blocks: CategoryBlockData[]): boolean {
  return blocks.some((block) => {
    if (!block.category) return false;

    return block.products.some((prod, idx) => {
      const product = prod?.trim() ?? "";
      const volume = normalizeVolume(block.volumes[idx]);
      return product && volume;
    });
  });
}
